import { useSignupOtp } from '../../hooks/useSignupOtp'
import { EmailOtpConfirmation } from '../email-otp-confirmation'

export interface EmailOtpStepProps {
  email: string
  basePath?: string
  nextUrl?: string
  onChangeEmail: () => void
  onCloseClick?: () => void
}

/**
 * OTP confirmation as an in-place step (used by the login iframe, which has no
 * URL routing). Owns the OTP logic via useSignupOtp; on a valid code it performs
 * an iframe-aware full-page redirect to the complete-data page.
 *
 * `nextUrl` must be passed explicitly: inside the iframe it comes from
 * `Bifrost.open()` at runtime, not from `window.location.search`. All other
 * /login query params are preserved automatically by useSignupOtp.
 */
export function EmailOtpStep({
  email,
  basePath,
  nextUrl,
  onChangeEmail,
  onCloseClick,
}: EmailOtpStepProps) {
  const { isLoading, error, setError, validateCode, resendCode } = useSignupOtp({
    email,
    basePath,
    nextUrl,
  })

  return (
    <EmailOtpConfirmation
      email={email}
      isLoading={isLoading}
      error={error}
      onComplete={validateCode}
      onResend={resendCode}
      onChangeEmail={onChangeEmail}
      onCodeChange={() => setError(undefined)}
      onCloseClick={onCloseClick}
    />
  )
}
